import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Modal from "../modal/Modal"; // Import Modal component
import { componentMapper } from "../../utils/componentMapper"; // Import componentMapper
import {
  FaTiktok,
  FaPlus,
  FaBars,
  FaSearch,
  FaSignInAlt,
  FaUserPlus,
  FaQuestionCircle,
  FaUserAlt,
  FaHome,
} from "react-icons/fa";
import { RiExpandRightLine, RiContractLeftLine } from "react-icons/ri";
import { GrProjects } from "react-icons/gr";
import { PiNotePencil, PiSquaresFour } from "react-icons/pi";
import {
  House,
  Globe,
  ArrowRightFromSquare,
  MusicNote,
  ArrowLeftFromLine,
  CircleQuestionFill,
  Plus,
  Circles4Square,
  ArrowRightFromLine,
  ChevronDown,
  ChevronUp,
  Person,
  Rectangles4,
  Rocket,
  CircleExclamation,
  Keyboard,
  Persons,
  Gear,
  PencilToLine,
  PersonPlus,
  ThumbsUp,
  Bars,
  File,
  Comments,
} from "@gravity-ui/icons";
import { LuMessageSquareWarning } from "react-icons/lu";
import { useAuth } from "../../contexts/AuthContext";
import { useLocalState } from "../../contexts/LocalStateProvider";
import AudioBars from "../custom_components/AudioBars";
import { usePostHog } from "posthog-js/react";
import {
  setRedirectAfterSelectedPlan,
  setSubscriptionModal,
  setSubscriptionTypeModal,
} from "../../store/reducers/subscriptionSlice";
import { useDispatch } from "react-redux";
import GameModal from "../custom_components/GameModal";
import { useGameContext } from "../../contexts/GameContext";
import { getCookie } from "../../utils/cookieUtils";
import axios from "axios";
import TaskCompletion from "../custom_components/TaskCompletion";

/* 
  This small modal component loads Zapier's script and displays the chatbot embed.
  We define it here so we can render it conditionally within Button.js whenever the 
  "Chat with us" dropdown option is clicked.
*/
function ZapierChatModal({ closeModal }) {
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://interfaces.zapier.com/assets/web-components/zapier-interfaces/zapier-interfaces.esm.js";
    script.type = "module";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return (
    <zapier-interfaces-chatbot-embed
      is-popup="true"
      chatbot-id="cm6914edy0092128fcfo820q7"
    />
  );
}

const getPartitionedKey = (key) => {
  if (window.Office && Office.context && Office.context.partitionKey) {
    return `${Office.context.partitionKey}_${key}`;
  }
  return key;
};
const setPartitionedLocalStorage = (key, value) => {
  localStorage.setItem(getPartitionedKey(key), value);
};
const getPartitionedLocalStorage = (key) => {
  return localStorage.getItem(getPartitionedKey(key));
};
const removePartitionedLocalStorage = (key) => {
  localStorage.removeItem(getPartitionedKey(key));
};

const iconComponents = {
  Comments,
  FaTiktok,
  FaPlus,
  FaBars,
  FaSearch,
  FaSignInAlt,
  FaUserPlus,
  FaQuestionCircle,
  RiExpandRightLine,
  RiContractLeftLine,
  GrProjects,
  FaUserAlt,
  PiNotePencil,
  House,
  Globe,
  ArrowRightFromSquare,
  MusicNote,
  ArrowLeftFromLine,
  CircleQuestionFill,
  Plus,
  PiSquaresFour,
  Circles4Square,
  ArrowRightFromLine,
  ChevronDown,
  ChevronUp,
  Person,
  Rectangles4,
  Rocket,
  CircleExclamation,
  Keyboard,
  Persons,
  Gear,
  PencilToLine,
  PersonPlus,
  ThumbsUp,
  LuMessageSquareWarning,
  Bars,
  File,
};

export default function Button(props) {
  const posthog = usePostHog();
  const {
    caption,
    path,
    url,
    className,
    icon,
    btnStyle,
    imgStyle,
    onClick,
    image,
    dropdownOptions,
    dropdownStyle,
    isSuggestion,
    iconStyle,
    svg,
    dropdownClick,
    musicEmoji,
    closeModal,
    createNew,
    trigger,
    renderComponents,
    onClickOption,
    signOut,
    id,
    userAvatar,
    tabPath,
    imgClassName,
    hoverImage,
    hoverVideo,
    hoverAudio,
    hoverImageStyle,
    hoverVideoStyle,
    tooltip,
    text,
    gameModalText,
    textStyle,
    isNotification,
    onlyShowIfLoggedIn, // Add this property
  } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);
  const { logout, login, isLoggedIn } = useAuth(); // Extract login, logout and isLoggedIn from useAuth
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const { localState, updateLocalState } = useLocalState();
  const [pageWidth, setPageWidth] = useState(window.innerWidth);
  const [isHovered, setIsHovered] = useState(false);
  const dispatch = useDispatch();
  const [showZapierChat, setShowZapierChat] = useState(false);
  const [showGameModal, setShowGameModal] = useState(false);

  const IconComponent = icon ? iconComponents[icon] : null;
  const activeClassName = "text-white";
  const [isActive, setIsActive] = useState(false);

  const { gamificationData, fetchGamificationData } = useGameContext();
  const completedTasksCount = gamificationData.tasks.filter(task => task.is_completed).length;
  const [triggerTaskModal, setTriggerTaskModal] = useState(false);

  const taskUpdate = async () => {
    if (gamificationData.tasks[8].is_completed === false) {
      const token = getCookie("token") || getPartitionedLocalStorage("token");
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_ENDPOINT}/api/complete-task`,
        { taskKey: "create_team" },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      //console.log(response.data)

      if (response.data.status === "completed") {
        setTriggerTaskModal(true);
        setTimeout(() => setTriggerTaskModal(false), 8000);
        await fetchGamificationData();
      }
    }
  }

  useEffect(() => {
    setIsActive(location.pathname === path);
  }, [location, path]);

  useEffect(() => {
    const handleResize = () => {
      setPageWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  // Determine if the button should be visible based on props and auth state
  // This doesn't use hooks conditionally - just computes a variable

  // Determine if the button should be visible based on props and auth state
  // This doesn't use hooks conditionally - just computes a variable
  const shouldRenderButton = !onlyShowIfLoggedIn || isLoggedIn;
  if (!shouldRenderButton) {
    return null;
  }

  const handleClick = (e) => {
    // Handle notification bell click to position modal at bottom of sidebar
    if (id === "help-button") {
      setShowZapierChat(true);
      posthog.capture("Click on Help icon to open Zapier chatbot", { is_user_logged_in: isLoggedIn ? true : false });
    }
    if (id === "game-button") {
      setShowGameModal(!showGameModal);
      posthog.capture("Click-OpenGameModal-HomePage", { is_user_logged_in: isLoggedIn ? true : false })
    }
    if (caption === "Sign Up") {
      posthog.capture("Click-ContinueWithEmail-SignUpModal", { is_user_logged_in: isLoggedIn ? true : false });
    }
    if (caption === "Forgot Password?") {
      posthog.capture("Click on Forgot Password Button", { is_user_logged_in: isLoggedIn ? true : false });
    }
    if (id === "sidebar-link-sign-in") {
      posthog.capture("Click-ContinueWithEmail-LoginModal", { is_user_logged_in: isLoggedIn ? true : false });
    } else if (caption === "Join the waitlist") {
      posthog.capture("Click on Join the Waitlist Button", { is_user_logged_in: isLoggedIn ? true : false });
    }
    if (id === "sidebar-link-invite-new-people") {
      posthog.capture("Click on Invite new people", { is_user_logged_in: isLoggedIn ? true : false });
    }
    if (id === "sidebar-link-create-team") {
      posthog.capture("Click on Create Team", { is_user_logged_in: isLoggedIn ? true : false });

    }

    if (onClickOption === "handleGoogleSignIn" || onClickOption === "handleGoogleSignUp") {
      const isSignIn = onClickOption === "handleGoogleSignIn";
      posthog.capture(`Click on Google ${isSignIn ? "Sign In" : "Sign Up"} Button`, { is_user_logged_in: isLoggedIn ? true : false });

      if (window.Office && window.Office.context && window.Office.context.ui) {
        // Office Add-in: Use a simpler approach with popup for better compatibility
        const authUrl = `${process.env.REACT_APP_SERVER_ENDPOINT}/api/auth/google?powerpoint=true`;
        console.log("[DEBUG] Attempting to open Office dialog for Google sign-in", authUrl);

        // Try the dialog API first, with fallback to popup
        Office.context.ui.displayDialogAsync(
          authUrl,
          { height: 70, width: 50 },
          function (result) {
            if (result.status === Office.AsyncResultStatus.Succeeded) {
              const dialog = result.value;
              console.log("[DEBUG] Office dialog opened successfully");

              // Add error handler for navigation issues
              dialog.addEventHandler(Office.EventType.DialogEventReceived, (args) => {
                if (args.error === 12004) {
                  console.log("[DEBUG] Domain navigation error, trying popup fallback...");
                  dialog.close();
                  // Fallback to popup window
                  const popup = window.open(authUrl, 'oauth', 'width=500,height=600');
                  console.log("[DEBUG] Popup fallback opened");
                  const checkClosed = setInterval(() => {
                    if (popup.closed) {
                      clearInterval(checkClosed);
                      // Check for token in partitioned localStorage (set by popup)
                      const token = getPartitionedLocalStorage('oauth_token');
                      const userId = getPartitionedLocalStorage('oauth_user_id');
                      console.log("[DEBUG] Popup closed. Partitioned Token:", token, "UserId:", userId);
                      if (token && userId) {
                        console.log("[DEBUG] Calling login from popup fallback");
                        setPartitionedLocalStorage('token', token);
                        setPartitionedLocalStorage('user_id', userId);
                        login(token, userId);
                        removePartitionedLocalStorage('oauth_token');
                        removePartitionedLocalStorage('oauth_user_id');
                        posthog.capture('Google Sign In Success in PowerPoint Add-in (Popup)', {
                          is_user_logged_in: true,
                          provider: 'Google'
                        });
                        // Trigger auth state refresh in main app
                        setPartitionedLocalStorage("justLoggedIn", "true");

                        // Universal modal close logic
                        if (window.Office && window.Office.context && window.Office.context.ui && typeof Office.context.ui.messageParent === 'function') {
                          Office.context.ui.messageParent("close-auth-modal");
                          console.log("[DEBUG] Sent close-auth-modal via Office.context.ui.messageParent");
                        } else if (window.opener && typeof window.opener.postMessage === "function") {
                          window.opener.postMessage("close-auth-modal", "*");
                          console.log("[DEBUG] Sent close-auth-modal via window.opener.postMessage");
                        } else {
                          window.dispatchEvent(new Event("close-auth-modal"));
                          console.log("[DEBUG] Dispatched close-auth-modal event");
                        }
                        window.dispatchEvent(new Event('authStateChanged'));
                        console.log("[DEBUG] Dispatched authStateChanged event");
                      }
                    }
                  }, 1000);
                }
              });

              dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
                try {
                  console.log("[DEBUG] Dialog message received:", arg.message);
                  // Parse the message from the AuthSuccess component
                  const authData = JSON.parse(arg.message);
                  console.log("[DEBUG] Auth data:", authData);
                  const { token, user_id, provider } = authData;

                  if (token && user_id) {
                    // Log the user in using the token
                    console.log("[DEBUG] Calling login from dialog message");
                    setPartitionedLocalStorage('token', token);
                    setPartitionedLocalStorage('user_id', user_id);
                    login(token, user_id);
                    console.log(`✅ ${provider} authentication successful in PowerPoint add-in`);

                    // Trigger PostHog event for successful authentication
                    posthog.capture(`${provider} Sign In Success in PowerPoint Add-in`, {
                      is_user_logged_in: true,
                      provider: provider
                    });

                    setPartitionedLocalStorage("justLoggedIn", "true");

                    // Universal modal close logic - always dispatch window event for modal closure
                    console.log("🚀 Google Dialog Auth Success - Dispatching close-auth-modal event for Mac PowerPoint compatibility");
                    window.dispatchEvent(new Event("close-auth-modal"));
                    console.log("[DEBUG] Dispatched close-auth-modal event");

                    // Additional messaging for other contexts if needed
                    if (window.opener && typeof window.opener.postMessage === "function") {
                      window.opener.postMessage("close-auth-modal", "*");
                      console.log("[DEBUG] Sent close-auth-modal via window.opener.postMessage");
                    }
                    // Trigger auth state refresh in main app
                    window.dispatchEvent(new Event('authStateChanged'));
                    console.log("[DEBUG] Dispatched authStateChanged event");


                    // Close the dialog
                    dialog.close();
                  } else {
                    console.error("Invalid authentication data received:", authData);
                    dialog.close();
                  }
                } catch (error) {
                  console.error("Error processing authentication message:", error);
                  dialog.close();
                }
              });
            } else {
              // Handle dialog error - fallback to popup
              console.log("[DEBUG] Dialog failed to open, falling back to popup. URL tried to open:", authUrl);
              console.error("Dialog failed to open:", result.error);

              // Fallback to popup window
              const popup = window.open(authUrl, 'oauth', 'width=500,height=600');
              console.log("[DEBUG] Popup fallback opened");
              const checkClosed = setInterval(() => {
                if (popup.closed) {
                  clearInterval(checkClosed);
                  // Check for token in partitioned localStorage (set by popup)
                  const token = getPartitionedLocalStorage('oauth_token');
                  const userId = getPartitionedLocalStorage('oauth_user_id');
                  console.log("[DEBUG] Popup closed. Partitioned Token:", token, "UserId:", userId);
                  if (token && userId) {
                    console.log("[DEBUG] Calling login from popup fallback");
                    setPartitionedLocalStorage('token', token);
                    setPartitionedLocalStorage('user_id', userId);
                    login(token, userId);
                    removePartitionedLocalStorage('oauth_token');
                    removePartitionedLocalStorage('oauth_user_id');
                    posthog.capture('Google Sign In Success in PowerPoint Add-in (Popup Fallback)', {
                      is_user_logged_in: true,
                      provider: 'Google'
                    });
                    // Trigger auth state refresh in main app
                    setPartitionedLocalStorage("justLoggedIn", "true");

                    // Universal modal close logic - always dispatch window event for modal closure
                    window.dispatchEvent(new Event("close-auth-modal"));
                    console.log("[DEBUG] Dispatched close-auth-modal event");

                    // Additional messaging for other contexts if needed
                    if (window.opener && typeof window.opener.postMessage === "function") {
                      window.opener.postMessage("close-auth-modal", "*");
                      console.log("[DEBUG] Sent close-auth-modal via window.opener.postMessage");
                    }
                    window.dispatchEvent(new Event('authStateChanged'));
                    console.log("[DEBUG] Dispatched authStateChanged event");
                  }
                }
              }, 1000);
            }
          }
        );
      } else {
        // Browser: Use direct redirect
        const googleAuthUrl = `${process.env.REACT_APP_SERVER_ENDPOINT}/api/auth/google`;
        console.log("[DEBUG] Not in Office context, redirecting to:", googleAuthUrl);
        window.location.href = googleAuthUrl;
        // Add commentMore actions
        localStorage.setItem("justLoggedIn", "true");

        // Universal modal close logic - always dispatch window event for modal closure
        window.dispatchEvent(new Event("close-auth-modal"));
        console.log("[DEBUG] Dispatched close-auth-modal event");

        // Additional messaging for other contexts if needed
        if (window.opener && typeof window.opener.postMessage === "function") {
          window.opener.postMessage("close-auth-modal", "*");
          console.log("[DEBUG] Sent close-auth-modal via window.opener.postMessage");
        }
      }
      return; // Stop further execution if redirecting
    }


    if (onClickOption === "handleMicrosoftSignIn" || onClickOption === "handleMicrosoftSignUp") {
      const isSignIn = onClickOption === "handleMicrosoftSignIn";
      posthog.capture(`Click on Microsoft ${isSignIn ? "Sign In" : "Sign Up"} Button`);

      if (window.Office && window.Office.context && window.Office.context.ui) {
        // Office Add-in: Use a simpler approach with popup for better compatibility
        const authUrl = `${process.env.REACT_APP_SERVER_ENDPOINT}/api/auth/microsoft?powerpoint=true`;

        // Try the dialog API first, with fallback to popup
        Office.context.ui.displayDialogAsync(
          authUrl,
          { height: 70, width: 50, displayInIframe: false },
          function (result) {
            if (result.status === Office.AsyncResultStatus.Succeeded) {
              const dialog = result.value;

              // Add error handler for navigation issues
              dialog.addEventHandler(Office.EventType.DialogEventReceived, (args) => {
                if (args.error === 12004) {
                  console.log("Domain navigation error, trying popup fallback...");
                  dialog.close();
                  // Fallback to popup window
                  const popup = window.open(authUrl, 'oauth', 'width=500,height=600');
                  const checkClosed = setInterval(() => {
                    if (popup.closed) {
                      clearInterval(checkClosed);
                      // Check for token in localStorage (set by popup)
                      const token = localStorage.getItem('oauth_token');
                      const userId = localStorage.getItem('oauth_user_id');
                      if (token && userId) {
                        login(token, userId);
                        localStorage.removeItem('oauth_token');
                        localStorage.removeItem('oauth_user_id');
                        posthog.capture('Microsoft Sign In Success in PowerPoint Add-in (Popup)', {
                          is_user_logged_in: true,
                          provider: 'Microsoft'
                        });
                        localStorage.setItem("justLoggedIn", "true");

                        // Universal modal close logic
                        if (window.Office && window.Office.context && window.Office.context.ui && typeof Office.context.ui.messageParent === 'function') {
                          Office.context.ui.messageParent("close-auth-modal");
                        } else if (window.opener && typeof window.opener.postMessage === "function") {
                          window.opener.postMessage("close-auth-modal", "*");
                        } else {
                          window.dispatchEvent(new Event("close-auth-modal"));
                        }
                        // Trigger auth state refresh in main app
                        window.dispatchEvent(new Event('authStateChanged'));
                      }
                    }
                  }, 1000);

                }
              });

              dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
                try {
                  // Parse the message from the AuthSuccess component
                  const authData = JSON.parse(arg.message);
                  const { token, user_id, provider } = authData;

                  if (token && user_id) {
                    // Log the user in using the token
                    login(token, user_id);
                    console.log(`✅ ${provider} authentication successful in PowerPoint add-in`);

                    // Optionally trigger PostHog event for successful authentication
                    posthog.capture(`${provider} Sign In Success in PowerPoint Add-in`, {
                      is_user_logged_in: true,
                      provider: provider
                    });

                    // Add commentMore actions
                    localStorage.setItem("justLoggedIn", "true");

                    // Universal modal close logic - always dispatch window event for modal closure
                    window.dispatchEvent(new Event("close-auth-modal"));

                    // Additional messaging for other contexts if needed
                    if (window.opener && typeof window.opener.postMessage === "function") {
                      window.opener.postMessage("close-auth-modal", "*");
                    }
                    // Trigger auth state refresh in main app
                    window.dispatchEvent(new Event('authStateChanged'));
                    setTimeout(() => {
                      window.location.reload(); // force UI re-render
                    }, 1000);

                    // Close the dialog
                    dialog.close();
                  } else {
                    console.error("Invalid authentication data received:", authData);
                    dialog.close();
                  }
                } catch (error) {
                  console.error("Error processing authentication message:", error);
                  dialog.close();
                }
              });
            } else {
              // Handle dialog error - fallback to popup
              console.log("URL tried to open:", authUrl);
              console.error("Dialog failed to open:", result.error);

              // Fallback to popup window
              const popup = window.open(authUrl, 'oauth', 'width=500,height=600');
              const checkClosed = setInterval(() => {
                if (popup.closed) {
                  clearInterval(checkClosed);
                  // Check for token in localStorage (set by popup)
                  const token = localStorage.getItem('oauth_token');
                  const userId = localStorage.getItem('oauth_user_id');
                  if (token && userId) {
                    login(token, userId);
                    localStorage.removeItem('oauth_token');
                    localStorage.removeItem('oauth_user_id');
                    posthog.capture('Microsoft Sign In Success in PowerPoint Add-in (Popup Fallback)', {
                      is_user_logged_in: true,
                      provider: 'Microsoft'
                    });

                    localStorage.setItem("justLoggedIn", "true");

                    // Universal modal close logic - always dispatch window event for modal closure
                    window.dispatchEvent(new Event("close-auth-modal"));

                    // Additional messaging for other contexts if needed
                    if (window.opener && typeof window.opener.postMessage === "function") {
                      window.opener.postMessage("close-auth-modal", "*");
                    }
                    // Trigger auth state refresh in main app
                    window.dispatchEvent(new Event('authStateChanged'));


                    // PowerPoint-specific: Force page refresh to ensure UI updates
                    console.log("🔄 PowerPoint: Forcing page refresh after fallback auth");
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  }
                }
              }, 1000);

            }
          }
        );
      } else {
        // Browser: Use direct redirect
        const microsoftAuthUrl = `${process.env.REACT_APP_SERVER_ENDPOINT}/api/auth/microsoft`;
        window.location.href = microsoftAuthUrl;
        // Add commentMore actions
        localStorage.setItem("justLoggedIn", "true");
        setTimeout(() => {
          window.location.reload(); // force UI re-render
        }, 1000);

        // Universal modal close logic - always dispatch window event for modal closure
        window.dispatchEvent(new Event("close-auth-modal"));

        // Additional messaging for other contexts if needed
        if (window.opener && typeof window.opener.postMessage === "function") {
          window.opener.postMessage("close-auth-modal", "*");
        }

      }
      return; // Stop further execution if redirecting
    }

    if (onClick) {
      onClick(e);
    }

    if (path) {
      navigate(path);
    }

    if (id === "continue-with-email-button") {
      posthog.capture("Click on Continue with Email Button", { is_user_logged_in: isLoggedIn ? true : false });
      // Handle email sign in modal
    }

    if (id === "sidebar-link-create-team") {
      posthog.capture("Click Create New Team", { is_user_logged_in: true });

      dispatch(setRedirectAfterSelectedPlan("/create-team"));
      dispatch(setSubscriptionModal(true));
      // localState.userProfileData?.remaining_credits == 0 ? dispatch(setSubscriptionModal(true)) : navigate("/create-team");
    }

    // For sidebar-create-new-button-label
    if (id === "sidebar-create-new-button-label") {
      if (localState?.userProfileData?.remaining_credits == 0) {
        if (localState.isAdmin && localState.isTeamMember) {
          dispatch(setRedirectAfterSelectedPlan("/create-team"));
          dispatch(setSubscriptionModal(true));
          dispatch(setSubscriptionTypeModal("upgrade"));
        } else if (!localState.isTeamMember) {
          dispatch(setRedirectAfterSelectedPlan("/create-team"));
          dispatch(setSubscriptionModal(true));
        }
        return;
      }

      posthog.capture("Click Create New Project", { is_user_logged_in: isLoggedIn ? true : false });
    }

    // For sidebar-link-home
    if (id === "sidebar-link-home") {
      posthog.capture("Click Home Navigation", { is_user_logged_in: isLoggedIn ? true : false });
    }

    // For sidebar-link-projects
    if (id === "sidebar-link-projects") {
      posthog.capture("Click Projects Navigation", { is_user_logged_in: isLoggedIn ? true : false });
    }

    // For sidebar-link-discover
    if (id === "sidebar-link-discover") {
      posthog.capture("Click Discover Navigation", { is_user_logged_in: isLoggedIn ? true : false });
    }

    // For sidebar-link-liked-tracks
    if (id === "sidebar-link-liked-tracks") {
      posthog.capture("Click Liked Tracks Navigation", { is_user_logged_in: isLoggedIn ? true : false });
    }

    if (id === "sidebar-link-feedback-form") {
      posthog.capture("Click to open Feedback Form", { is_user_logged_in: isLoggedIn ? true : false });
    }
    if (id === "sidebar-settings-button") {
      posthog.capture("Click Settings Icon", { is_user_logged_in: isLoggedIn ? true : false });
    }
    if (id === "sidebar-link-help") {
      posthog.capture("Click Help Navigation"), { is_user_logged_in: isLoggedIn ? true : false };
    }
    if (id === "footer-link-about") {
      posthog.capture("Click on About link footer", { is_user_logged_in: isLoggedIn ? true : false });
    }
    if (id === "footer-link-features") {
      posthog.capture("Click on Features link footer", { is_user_logged_in: isLoggedIn ? true : false });
      console.log("Features link clicked and logged to PostHog");
    }
    if (id === "footer-link-resources") {
      posthog.capture("Click on Resources link footer", { is_user_logged_in: isLoggedIn ? true : false });
      console.log("Resources link clicked and logged to PostHog");
    }
    if (id === "footer-link-contact") {
      posthog.capture("Click on Contact link footer", { is_user_logged_in: isLoggedIn ? true : false });
      console.log("Contact link clicked and logged to PostHog");
    }
    if (id === "footer-link-pricing") {
      posthog.capture("Click on Pricing link footer", { is_user_logged_in: isLoggedIn ? true : false });
      console.log("Pricing link clicked and logged to PostHog");
    }

    if (trigger === "closeModal") {
      // Close the modal if the trigger is closeModal
      onClick && onClick();

      if (signOut) {
        logout();
        navigate("/");
      }
    }

    if (dropdownOptions) {
      e.stopPropagation();
      setDropdownVisible(!dropdownVisible);
    }

    if (onClick === "handleSignOut") {
      logout();
      navigate("/");
      return;
    }

    // if (onClick) {
    //   onClick(e);
    //   if (icon === "ArrowRightFromLine") updateLocalState("longSidebar", true);
    //   else if (icon === "ArrowLeftFromLine")
    //     updateLocalState("longSidebar", false);
    // }

    if (isSuggestion) {
      posthog.capture("Click on Suggestion Prompt Button", { is_user_logged_in: isLoggedIn ? true : false });

      const mediaData = {
        text: caption,
      };

      const fetchFileAsBinary = async (filePath, type) => {
        const response = await fetch(filePath);
        const arrayBuffer = await response.arrayBuffer();
        return new File([arrayBuffer], filePath.split("/").pop(), { type });
      };

      const handleMediaFile = async () => {
        if (hoverVideo) {
          const videoFile = await fetchFileAsBinary(
            "/Minecraft.mp4",
            "video/mp4"
          );
          mediaData.file = {
            name: hoverVideo.split("/").pop(),
            type: "video/mp4",
            file: videoFile,
            url: "gs://wubble-storage/audio/user-uploads/Minecraft.mp4",
          };
        } else if (hoverAudio) {
          const audioFile = await fetchFileAsBinary(
            "/Sunset Lofi.wav",
            "audio/wav"
          );
          mediaData.file = {
            name: hoverAudio.split("/").pop(),
            type: "audio/wav",
            file: audioFile,
            url: "gs://wubble-storage/audio/user-uploads/Sunset Lofi.wav",
          };
        } else if (hoverImage) {
          const imageFile = await fetchFileAsBinary("/Coffee.png", "image/png");
          mediaData.file = {
            name: hoverImage.split("/").pop(),
            type: "image/png",
            file: imageFile,
            url: "gs://wubble-storage/audio/user-uploads/Coffee.png",
          };
        }

        updateLocalState("suggestionClicked", mediaData);
      };

      handleMediaFile();
    }

    if (path) {
      posthog.capture("Navigation", { is_user_logged_in: isLoggedIn ? true : false, destination: path });
      navigate(path);
    }

    if (userAvatar && pageWidth < 768) {
      posthog.capture("Navigation", { is_user_logged_in: true, destination: "/settings" });
      navigate("/settings");
    }
    if (tabPath && tabPath === "organization") {
      posthog.capture("Navigation", { is_user_logged_in: true, destination: "/settings" });
      updateLocalState("organizationClicked", true);
      navigate("/settings");
    } else if (tabPath && tabPath === "organizationInvite") {
      posthog.capture("Navigation", { destination: "/settings" });
      updateLocalState("organizationClicked", true);
      updateLocalState("organizationInviteClicked", true);
      navigate("/settings");
    }

    if (url) {
      posthog.capture("External Navigation", { is_user_logged_in: isLoggedIn ? true : false, destination: url });
      window.location.href = url; // Navigate to external URL
    }
  };

  const handleDropdownClick = (option) => {
    // If user clicked "Chat with us", show the Zapier chatbot modal
    if (option?.id === "dropdown-chat-with-us") {
      setDropdownVisible(false);
      setShowZapierChat(true);
      return;
    }

    posthog.capture("Click on Dropdown Option", { is_user_logged_in: isLoggedIn ? true : false, option: option.label });
    if (option?.url) {
      posthog.capture("External Navigation", { is_user_logged_in: isLoggedIn ? true : false, destination: option.url });
      window.location.href = option.url; // Navigate to external URL
    } else if (path) {
      posthog.capture("Navigation", { is_user_logged_in: isLoggedIn ? true : false, destination: path });
      navigate(path); // Navigate within the app
    } else if (option.path) {
      posthog.capture("Navigation", { is_user_logged_in: isLoggedIn ? true : false, destination: option.path });
      navigate(option.path);
    } else if (onClickOption) {
      posthog.capture("Navigation", { is_user_logged_in: isLoggedIn ? true : false, destination: option.path });
      onClickOption();
    }
    setDropdownVisible(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownVisible(false);
      setShowZapierChat(false);
    }
  };

  const DropdownIcon = dropdownVisible ? ChevronUp : ChevronDown;

  const userAgent = navigator.userAgent.toLowerCase();

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button
        id={id}
        style={btnStyle}
        className={`${className} ${isActive && activeClassName}`}
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <>
          {image && (
            <img
              style={imgStyle}
              src={image}
              alt={caption}
              className={`${imgClassName ? imgClassName : `w-6 h-6`}`}
            />
          )}
          {svg && <img src={svg} alt="icon" className={`${iconStyle}`} />}
          {gameModalText && <span className={textStyle}>{completedTasksCount}</span>}
          {IconComponent && <IconComponent className={`${iconStyle}`} />}
          {musicEmoji && (
            <div className="mr-1.5">
              {musicEmoji}
            </div>
          )}
          {caption && <div className="truncate max-w-80">{caption}</div>}
          {props.children && props.children}
          {tooltip && isHovered && (
            <div
              className={`absolute z-40 ${tooltip == "Liked tracks" ||
                tooltip == "Create new" ||
                tooltip == "Sign in"
                ? `w-24`
                : `w-auto`
                } top-8 flex items-center justify-center left-6 mt-1 px-2 h-7 text-sm text-white bg-white/20 rounded backdrop-blur-[20px] shadow-lg z-10`}
            >
              {tooltip}
            </div>
          )}
        </>
        {dropdownClick && !userAvatar && (
          <DropdownIcon className={`${iconStyle}`} />
        )}
        {createNew && (
          <div className="absolute right-3 text-xs flex items-center">
            {userAgent.includes("win") ? (
              <>
                <img
                  src="/ctrl.svg"
                  alt="Control Key Icon"
                  className="mr-0.5"
                />
                <img src="/keyword-I.svg" alt="Keyword I Icon" />
              </>
            ) : (
              <>
                <img src="/cmd.svg" alt="Command Key Icon" className="mr-0.5" />
                <img src="/keyword-I.svg" alt="Keyword I Icon" />
              </>
            )}
          </div>
        )}
        {hoverImage && isHovered && (
          <img
            src={hoverImage}
            alt="Hover preview"
            className={hoverImageStyle}
          />
        )}
        {hoverVideo && isHovered && (
          <video
            src={hoverVideo}
            className={hoverVideoStyle}
            type="video/mp4"
            loop
            autoPlay
          />
        )}
        {hoverAudio && isHovered && <AudioBars />}
        {hoverAudio && isHovered && <audio autoPlay src={hoverAudio} />}
      </button>
      {(!userAvatar || pageWidth >= 768) &&
        dropdownVisible &&
        dropdownOptions && (
          <div className={dropdownStyle}>
            {dropdownOptions.map((option) => {
              const OptionIcon = iconComponents[option.icon];
              return (
                <div
                  id={option.id}
                  key={option.label}
                  onClick={() => handleDropdownClick(option)}
                  className={`px-2 py-2 cursor-pointer rounded-lg flex items-center gap-2 hover:[background:var(--Color-Opacity-White-5,rgba(255,255,255,0.05))] ${option.textStyle}`}
                >
                  {OptionIcon && <OptionIcon className="w-4 h-4" />}
                  {option.img && <img src={option.img} alt={option.label} />}
                  {option.label}
                </div>
              );
            })}
          </div>
        )}
      {showGameModal && <GameModal onClose={() => setShowGameModal(false)} />}


      {showZapierChat && (
        <iframe
          src="https://interfaces.zapier.com/embed/chatbot/cm6914edy0092128fcfo820q7"
          height="480px"
          width="360px"
          allow="clipboard-write *"
          style={{
            borderRadius: "8px",
            position: "fixed",
            bottom: "72px",
            right: "20px",
          }}
        ></iframe>
      )}

    </div>
  );
}

function renderModalContent(modalContent, renderComponents) {
  return renderComponents([modalContent]);
  // const { name, props, children } = modalContent;
  // const ComponentToRender = componentMapper[name];

  // if (!ComponentToRender) {
  //   console.error(`Component "${name}" not found in componentMapper.`);
  //   return null;
  // }

  // return (
  //   <ComponentToRender {...props}>
  //     {children &&
  //       children.map((child, index) =>
  //         renderModalContent({
  //           name: child.name,
  //           props: { ...child.props, key: index },
  //           children: child.children,
  //         })
  //       )}
  //   </ComponentToRender>
  // );
}